import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_VEHICLE_MOVEMENT_RECORDS](state, data) {
    state.allVehicleMovementRecords = data
  },
  [types.SAVE_VEHICLE_MOVEMENT_RECORD](state, data) {
    state.vehicleMovementRecord.push(data)
  },
}
